import React, { useEffect } from 'react';
import { useSearchParams, Routes, Route, useNavigate, useMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { initLang, initTexts } from '../store/translate/translate-actions';
import { contestActions } from '../store/contest/contestSlice.js';
import { fetchActiveContests } from '../store/contest/contest-actions';
import { getDefaultContest, getDefaultContestBySchool, getDefaultContestForStudent } from '../ui/builders/utils';
import useAnalytics from '../hooks/useAnalystics.js';
import LayoutContest from './LayoutContest/LayoutContest.js';
import Layout from './Layout/Layout';
import apm from '../apm.js';
import ContestComponent from './ContestComponent/ContestComponent';
import FinalPage from '../pages/FinalPage/FinalPage';
import Icode from '../pages/Icode/Icode';
import classes from './App.module.scss';

const App = () => {

    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const { isAuth, user, userDetails, isStudent, school, initAuthDetails } = useSelector((state) => state.auth);
    const { lang } = useSelector((state) => state.translate);
    const { activeContests } = useSelector((state) => state.contest);
    const navigate = useNavigate();
    const match = useMatch('/:contestId');
    const contestId = match?.params?.contestId;

    useAnalytics();

    useEffect(() => {
        const currentLangFromUrl = searchParams.get("lang");
        if (isAuth !== null) {
            dispatch(initLang({ currentLang: currentLangFromUrl, user: user, userDetails: userDetails }));
        }
    }, [dispatch, isAuth, user, userDetails, searchParams]);

    useEffect(() => {
        const hasApm = !!apm;
        const userExidentifier = user?.exidentifier;
        const userName = user?.name;
        if (isAuth && user && userExidentifier && hasApm) {
            apm.setUserContext({ id: userExidentifier || '-', username: userName || '-' });
        }
    }, [user, isAuth]);

    useEffect(() => {
        if (isAuth !== null && lang) {
            if (isAuth === true)
                userDetails && dispatch(initTexts());
            else
                dispatch(initTexts());
        }
    }, [dispatch, userDetails, isAuth, lang]);

    useEffect(() => {
        if (isAuth !== null && lang) {
            dispatch(fetchActiveContests(lang));
        }
    }, [dispatch, isAuth, lang]);

    useEffect(() => {
        if (activeContests.length && initAuthDetails && !contestId) {
            const defaulcontestId = getMyDefaulContestId();
            dispatch(contestActions.setCurrentContestId(defaulcontestId));
            navigate(`/${defaulcontestId}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- getMyDefaulContestId defined below; navigate is stable
    }, [contestId, initAuthDetails, activeContests, dispatch]);


    if (isAuth === null) {
        return null;
    }

    const getMyDefaulContestId = () => {
        if (!activeContests.length || !initAuthDetails || contestId) {
            return null;
        }
        let contest = null;
        if (isStudent)
            contest = getDefaultContestForStudent(activeContests, userDetails, school?.id);
        else
            contest = getDefaultContestBySchool(activeContests, school);
        if (!contest)
            contest = getDefaultContest(activeContests) ?? 14000;
        return contest?.id;
    };

    return (
        <div className={classes.App}>
            <Routes>
                <Route path="/icode" element={<Icode />} />
                <Route element={<Layout />}>
                    <Route path="/finalPage" element={<FinalPage />} />
                    <Route element={<LayoutContest />}>
                        <Route path="/:contestId" element={<ContestComponent />} />
                   </Route>
                </Route>
            </Routes>
        </div>
    );
}

export default App;